import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { usePartnerContext } from '../../context'
import {
  SAMPLE_DATA_TOOLTIP_ID,
  isSampleTemplatePartner
} from '../../helpers/sample-data'

/**
 * Label "Beispiel" an Stellen und Talenten. Neutral grau und eckig, damit es
 * weder wie ein Status (runde Pills) noch wie eine Warnung wirkt. Der Tooltip
 * ist einmal global in Layout gemountet (SAMPLE_DATA_TOOLTIP_ID) und öffnet
 * per Hover. Kein Tab-Stopp, weil das Label oft in Combobox-Optionen steht,
 * Screenreader lesen den sr-only-Text. relative hält diesen Text im Label,
 * sonst verlängert er in Scroll-Containern die Seite.
 */
const SampleBadge = ({ kind, className }) => {
  const { t } = useTranslation()
  const { partner } = usePartnerContext()

  const label = t('sample_data.badge.label')
  const tooltip = isSampleTemplatePartner(partner?.id)
    ? t('sample_data.badge.tooltip_template')
    : t(
        kind === 'talent'
          ? 'sample_data.badge.tooltip_talent'
          : 'sample_data.badge.tooltip_career'
      )

  return (
    <span
      data-tooltip-id={SAMPLE_DATA_TOOLTIP_ID}
      data-tooltip-content={tooltip}
      className={clsx(
        'relative inline-flex shrink-0 items-center rounded-md bg-gray-50 px-1.5 py-0.5 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/20',
        className
      )}
    >
      {label}
      <span className='sr-only'>. {tooltip}</span>
    </span>
  )
}

SampleBadge.propTypes = {
  kind: PropTypes.oneOf(['career', 'talent']),
  className: PropTypes.string
}

SampleBadge.defaultProps = {
  kind: 'career',
  className: undefined
}

export default SampleBadge
